// IMPORTANT: only add true bootstrapping operations to this file.  If in doubt check with 2 other people to get their opinions
import {initializeApp} from 'firebase/app';
import firebase from 'firebase/compat/app';
import {firebaseConfig} from "@/config";
initializeApp(firebaseConfig);
firebase.initializeApp(firebaseConfig);
